<template>
  <div class="incentive-detail">
    <!-- 活动参与详情 -->
    <NavHeaderBar :showSearch="false" navBarTitle="Event Participation Details">
    </NavHeaderBar>
    <ProductDetail v-if="infoObj.orderType === 0" :infoObj="infoObj" />
    <JoinCommunity v-if="infoObj.orderType === 3" :infoObj="infoObj" />
    <UploadDetail v-else :infoObj="infoObj" />
    <div class="bottom-action">
      <!-- 查看门店激励情况 -->
      <van-button class="view-btn" type="info" block @click="toUrl">{{ $t('button.viewStoreMotivationStatus') }}</van-button>
    </div>
  </div>
</template>

<script>
import { activityOrderInfoApi } from '@/api/incentive'
import { Toast } from 'vant'
export default {
  name: 'PointsDetail',
  components: {
    ProductDetail: () => import('./components/ProductDetail'),
    UploadDetail: () => import('./components/UploadDetail'),
    JoinCommunity: () => import('./components/joinCommunity')
  },
  data () {
    return {
      scanId: '',
      infoObj: {}
    }
  },
  activated () {
    const { scanId } = this.$route.query
    this.scanId = scanId
    this.getInfo()
  },
  methods: {
    getInfo () {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      activityOrderInfoApi(this.scanId).then(res => {
        Toast.clear()
        const { imgUrl, status } = res.data
        res.data.imgUrl = imgUrl ? imgUrl.split(',') : []
        res.data.statusColor = status === 10 ? '#ee541b' : status === 1 ? '#0db00b' : status === -1 ? '#c4200b' : status === 0 ? '#898989' : '#000'
        res.data.statusText = status === 10 ? this.$t('shared.completed') : status === 1 ? this.$t('shared.pendingReview') : status === -1 ? this.$t('shared.rejected') : status === 0 ? this.$t('shared.underReview') : ''
        this.infoObj = res.data
      })
    },
    toUrl () {
      this.$router.push(`/storeIncentive?customerId=${this.infoObj.customerId}`)
    }
  }
}
</script>

<style lang="less" scoped>
.incentive-detail {
  display: flex;
  flex-direction: column;
  height: 100%;
}
</style>
